import React from 'react';
import PropTypes from 'prop-types';
import JourneyWidget from './JourneyWidget';
import { Provider } from 'react-redux';
import store from '../store';

const Widget = ({ cmsLocale }) => {
  return (
    <div className="Widget journey-ai-widget">
      <Provider store={store}>
        <JourneyWidget cmsLocale={cmsLocale} />
      </Provider>
    </div>
  );
};

Widget.propTypes = {
  cmsLocale: PropTypes.string,
};

export default Widget;
